import { cloneDeep, isEqual } from "lodash";
import { useRef } from "react";

// Provides a deep memoized value that will be stable according to lodash's isEqual function
export function useDeepMemo<T>(value: T): T {
  const valueRef = useRef<T>(value);
  const snapshotRef = useRef<T>(cloneDeep(value));
  if (!isEqual(snapshotRef.current, value)) {
    snapshotRef.current = cloneDeep(value);
    valueRef.current = value;
  }
  return valueRef.current;
}
